var map = {
	"./demos/basic/index.ts": 43945,
	"./demos/beforeChange/index.ts": 90861,
	"./demos/disabled/index.ts": 91220,
	"./demos/onOff/index.ts": 87824,
	"./demos/size/index.ts": 1481,
	"./demos/value/index.ts": 79025,
	"./demos/widthHeight/index.ts": 68046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57654;